import { useRef, useEffect, useState } from "react";
import generatePDF from "react-to-pdf";

import { Box } from "@mui/material";

import { ProductReportPages } from "../../../products/ProductReport";

import { uploadFileToStorage } from "../../../../../helpers/firebase";
import { getAccountId } from "../../../../../helpers/accountHelpers";

const SETTLE_DELAY_MS = 3000;

const ProductPdfCapture = ({ product, onUploaded, onError }) => {
  const targetRef = useRef(null);
  const [settled, setSettled] = useState(false);
  const hasStarted = useRef(false);
  const onUploadedRef = useRef(onUploaded);
  const onErrorRef = useRef(onError);
  onUploadedRef.current = onUploaded;
  onErrorRef.current = onError;

  useEffect(() => {
    const timer = setTimeout(() => setSettled(true), SETTLE_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!settled || hasStarted.current) {
      return;
    }
    hasStarted.current = true;

    const generate = async () => {
      try {
        const pdf = await generatePDF(targetRef, {
          method: "build",
          page: { format: "letter" }
        });
        const blob = pdf.output("blob");
        const accountId = getAccountId();
        const storagePath = `${accountId}/reports/products/${product.id}/product-report.pdf`;
        const url = await uploadFileToStorage({
          path: storagePath,
          fileObject: blob,
          fileMetadata: { contentType: "application/pdf" },
          hasUserConfirmedUpload: true
        });
        onUploadedRef.current(url);
      } catch (e) {
        onErrorRef.current(e);
      }
    };

    generate();
  }, [settled, product.id]);

  return (
    <Box
      style={{
        position: "absolute",
        left: "-9999px",
        top: 0,
        width: "816px",
        overflow: "hidden"
      }}
    >
      <Box ref={targetRef}>
        <ProductReportPages product={product} pdfLoading={true} />
      </Box>
    </Box>
  );
};

export default ProductPdfCapture;
